import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Ambulance, Zap, Car, Home, Building2, Pill, Syringe, BrainCircuit, HeartHandshake, ArrowRight, Shield } from 'lucide-react';
export const Services = () => {
  const emergencyServices = [{
    icon: Ambulance,
    title: 'Вивід із запою',
    desc: 'Виклик лікаря за 30–60 хв, стаціонар або дім. Крапельниці, детоксикація під постійним наглядом лікаря.'
  }, {
    icon: Zap,
    title: 'Турбо Детокс',
    desc: 'Експрес-очищення організму за 24 години. Швидке відновлення працездатності.'
  }, {
    icon: Car,
    title: 'Трансфер',
    desc: 'Безпечне та анонімне перевезення пацієнта до стаціонару у супроводі медичної бригади.'
  }];
  const treatmentServices = [{
    icon: Building2,
    title: 'Стаціонар',
    desc: 'Цілодобове медичне спостереження, комфортні індивідуальні палати, повна ізоляція.'
  }, {
    icon: Pill,
    title: 'Кодування',
    desc: 'Медикаментозне та психотерапевтичне. Індивідуальний підбір методики.'
  }, {
    icon: Syringe,
    title: 'Підшивка',
    desc: 'Імплантація препаратів пролонгованої дії. Тривалий захист від рецидивів.'
  }, {
    icon: BrainCircuit,
    title: 'Психолог',
    desc: 'Індивідуальні та групові заняття. Робота з першопричинами залежності.'
  }, {
    icon: HeartHandshake,
    title: 'Реабілітація',
    desc: "Повний курс відновлення. Повернення фізичного здоров'я та соціальна адаптація."
  }, {
    icon: Shield,
    title: 'Допомога військовим',
    desc: 'Спеціальна програма лікування ПТСР та алкогольної залежності. Адаптовані методики, робота з бойовою травмою.'
  }];
  const ServiceCard = ({
    service,
    idx
  }: {
    service: any;
    idx: number;
  }) => <FadeIn delay={idx * 0.1} className="group cursor-pointer h-full" data-id="element-215">
      <div className="h-full p-8 border border-gray-200 bg-white transition-all duration-300 hover:-translate-y-1 hover:border-black hover:shadow-xl flex flex-col" data-id="element-216">
        <service.icon className="w-8 h-8 mb-6 text-black" strokeWidth={1} data-id="element-217" />
        <h4 className="text-xl font-bold mb-3" data-id="element-218">{service.title}</h4>
        <p className="text-gray-600 text-sm leading-relaxed mb-8 flex-grow" data-id="element-219">
          {service.desc}
        </p>
        <Button variant="outline" className="w-full group-hover:bg-black group-hover:text-white group-hover:border-black transition-all duration-300" data-id="element-220">
          Детальніше про послугу
        </Button>
      </div>
    </FadeIn>;
  return <section id="services" className="py-24 bg-white" data-id="element-221">
      <div className="container mx-auto px-4 md:px-6" data-id="element-222">
        <FadeIn data-id="element-223">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 max-w-2xl" data-id="element-224">
            Наші послуги
          </h2>
        </FadeIn>

        <div className="mb-20" data-id="element-225">
          <FadeIn data-id="element-226">
            <h3 className="text-xl font-medium text-gray-500 uppercase tracking-wider mb-8 flex items-center gap-4" data-id="element-227">
              Невідкладна допомога
              <div className="h-px bg-gray-200 flex-grow" data-id="element-228" />
            </h3>
          </FadeIn>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-229">
            {emergencyServices.map((service, idx) => <ServiceCard key={idx} service={service} idx={idx} data-id="element-230" />)}
          </div>
        </div>

        <div data-id="element-231">
          <FadeIn data-id="element-232">
            <h3 className="text-xl font-medium text-gray-500 uppercase tracking-wider mb-8 flex items-center gap-4" data-id="element-233">
              Лікування та відновлення
              <div className="h-px bg-gray-200 flex-grow" data-id="element-234" />
            </h3>
          </FadeIn>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-235">
            {treatmentServices.map((service, idx) => <ServiceCard key={idx} service={service} idx={idx} data-id="element-236" />)}
          </div>
        </div>
      </div>
    </section>;
};